"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgSelection(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm2 8h-1v-2h1zm10-8h-2v1h2zm-10 3h-1v2h1zm12-1h1v-2h-2v1h1zm1 1h-1v2h1zm-1 5h1v-2h-1zm0 1v.569l1 1.13641v-1.70541zm-7 2h2v-1h-2zm-3-10h2v-1h-2zm3 0h2v-1h-2zm-5 8h-1v2h2v-1h-1zm2 2h2v-1h-2zm-3-9h1v-1h1v-1h-2zm9.9932 11.994v-5.7862a.24652.24652 0 0 1 .0526-.1461.18355.18355 0 0 1 .2834-.0141l3.6161 4.1093a.22878.22878 0 0 1 .0443.0764.23449.23449 0 0 1 -.1095.2898l-1.2639.5724.8275 2.2721a.24094.24094 0 0 1 -.1103.2919l-.7222.3376h-.0803a.18592.18592 0 0 1 -.1805-.1316l-.8275-2.2549-1.2639.5723a.15291.15291 0 0 1 -.1805 0 .24636.24636 0 0 1 -.0853-.1889z' })));
}
exports.default = SvgSelection;
